import { Component, ChangeDetectionStrategy, inject, computed, input, output, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { trigger, transition, query, style, stagger, animate } from '@angular/animations';
import { ResizeService } from '../../auth.service';
import { NgTemplateOutlet } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InViewportModule } from 'ng-in-viewport';

@Component({
  selector: 'item-grid',
  templateUrl: './item-grid.component.html',
  styleUrls: ['./item-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[style.--item-width]': 'item_width() + "px"'
  },
  animations: [
    trigger('listAnim', [
      transition(':enter, * => -1', []),
      transition(':increment', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(40px)' }),
          stagger(100, [
            animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
          ]),
        ], { optional: true })
      ]),
      transition(':decrement', [
        query(':leave', [
          stagger(50, [
            animate('300ms ease-out', style({ opacity: 0, transform: 'translateY(-100px)' })),
          ]),
        ])
      ]),
      transition('* => 0', [
        query(':leave', [
          stagger(50, [
            animate('300ms ease-out', style({ opacity: 0, transform: 'translateY(-100px)' })),
          ]),
        ])
      ]),
    ])
  ],
  imports: [MatButtonModule, MatIconModule, InViewportModule, NgTemplateOutlet]
})
export class ItemGridComponent {
  private destroy: Subject<void> = new Subject<void>();

  size = inject(ResizeService);

  item_template = input.required<TemplateRef<any>>();
  item_width = input.required<number>();
  items = input.required<any[]>();

  item_name = input<string>('Items');
  item_track_key = input<string>('_id');
  isFinal = input<boolean>(false);
  loading = input<boolean>(false);

  loadMore = output<void>();

  total = computed(() => this.items() ? this.items()?.length : -1);

  viewportTrigger(event: { target: Element, visible: boolean }){
    // console.log('TRIGGER', event, this.isFinal(), this.loading());
    if(this.loading()) {
      setTimeout(() => {
          if(!this.destroy.closed)
            this.viewportTrigger(event);
      }, 1000);
      return;
    }
    if(event.visible && !this.isFinal()){
      this.loadMore.emit();
    }
  }

  ngOnDestroy(){
    this.destroy.next();
    this.destroy.complete();
  }

}
